import { useCountUp } from '../../hooks/useCountUp';

export default function StatCard({ to, suffix, label, desc, delay = 0 }) {
  const { ref, value } = useCountUp(to);

  const fmt = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return (
    <div className={`stat-item reveal${delay ? ` reveal-d${delay}` : ''}`} ref={ref}>
      <div className="stat-num">
        {fmt(value)}
        {suffix && <span className="suffix">{suffix}</span>}
      </div>
      <div className="stat-label">{label}</div>
      {desc && <div className="stat-desc">{desc}</div>}
    </div>
  );
}
